import Icon from '@icon/Icon';

const ChevronLeft = (props) => (
  <Icon
    {...props}
    viewBox=" 0 0 24 24"
    path="M15.3203 6.87748C15.693 7.24746 15.693 7.8473 15.3203 8.21727L10.9043 12.6L15.3203 16.9827C15.693 17.3527 15.693 17.9526 15.3203 18.3225C14.9475 18.6925 14.3431 18.6925 13.9703 18.3225L8.87943 13.2699C8.50666 12.8999 8.50666 12.3001 8.87943 11.9301L13.9703 6.87748C14.3431 6.50751 14.9475 6.50751 15.3203 6.87748Z"
  />
);

export default ChevronLeft;
